import FooterComponent from "../../component/Footer";

// -----------React hooks collection--------------------
import { useSelector } from "react-redux";
// -------------Data collection----------------------------
import AboutContainer from "./AboutContainer";
import { TestimonialCarossel } from "../../component/Carossel/Testimonial.carossel";

import SearchByCategory from "../../component/home/SearchByCategory";
import SearchByLocation from "../../component/home/SearchByLocation";
import Choices from "../../component/home/Choices";
import ProductSection from "../../component/home/ProductSection";
import { useFetchData } from "../../hooks/useFtechData";
import { ALL_JOB, ALL_STAT } from "../../resources/resource";
import { getJobByFunction, getJobsByLocations } from "./data";
import Hero from "./hero";
import Counter from "./countrt";
import Statistics from "./statistics";
import Notification from "./notification";
import Video from "./video";
import ApplicationStepContainer from "../application/ApplicationStepContainer";
import JobGrid from "../../component/JobGrid";
import JobSeekerStats from "../../component/job/JobSeekerStats";
import JobTitleCounts from "../../component/job/JobTitleCount";
import HRJob from "./HRJob";
import SearchComponent from "../Employer/SearchComponent";
import Banner from "./Ad.jsx"
import NewFooterComponent from "../../component/NewFooter.jsx";
import ApplicationForm from "../../component/home/ApplicationForm.jsx";
import JobList from "../../Admin/JobList.jsx";
import MarketerBanner from "../../adminLatest/MarketerBanner.jsx";
import BannerWhatsApp from "../../component/home/BannerWhatsapp.jsx";
import VideosPage from "../EmbedVideo.jsx";

function Homepage() {
  const allNotifications = useSelector(
    (state) => state.notification.notificationList
  );

  

  // ---------Pagination data----------
  const { data: jobData } = useFetchData(ALL_JOB);
  const { data: statData } = useFetchData(ALL_STAT);

  return (
    <div className="overflow-x-hidden">
      {/* ----------------Hero Section---------------- */}
      <Hero />
    

      {/* ------------Job section------------- */}
      <Counter statData={statData} />


       {/* ------------Job posted------------- */}
      <JobGrid />
      <ApplicationForm />

    <section className="w-full ">
        <Banner/>
      </section>

 <div className="w-full min-h-screen bg-white flex flex-col items-center">
  <section className="my-20 w-full px-5 sm:px-20 py-16 bg-gray-50">
    <SearchByCategory data={getJobByFunction(jobData)} />
  </section>

  <BannerWhatsApp/>

  {/* <section className="my-20 w-full px-5 sm:px-20 py-16 bg-orange-50">
    <SearchByLocation data={getJobsByLocations(jobData)} />
  </section> */}

  {/* <JobSeekerStats /> */}
  <JobTitleCounts />
</div>

<VideosPage />

      {/* ---------------Advert section---------------- */}
      <section className="w-full ">
        <Banner/>
      </section>

      {/* <HRJob /> */}

      {/* --------------- */}
      <ApplicationStepContainer />

      <MarketerBanner/>

      {/* -------------Video section--------------- */}
      <Video />

      {/* ----------------Choices Section------------------- */}
      {/* <section className="my-20 sm:px-20 px-5 border-t-4 py-4 border-b-4 border-orange-500">
        <Choices />
      </section> */}

      {/* ------------Job search section------------- */}

      {/* ------------Advert Section--------------------- */}
      <section className="w-full">
       <Banner/>
      </section>

      <JobList/>

      {/* ----------------About section------------- */}
      <AboutContainer />

      {/* --------------Product Section----------------- */}
      {/* <section className="my-20 sm:px-20 px-5">
        <ProductSection />
      </section> */}

      {/* -------------------Testimonial Page-------------------- */}
      <section className="bg-slate-300 my-20 sm:px-20 py-10">
        <h3 className="mx-auto mb-8 text-xl font-semibold border-b-2 border-orange-500 w-fit">
          Happy Employers
        </h3>
        <TestimonialCarossel />
      </section>

      {/* ------------------Statistic Section-------------------- */}
      {/* <Statistics statData={statData} /> */}
      {/* ----------------Notification section----------------- */}
      {/* <Notification allNotifications={allNotifications} /> */}
{/* 
      <FooterComponent /> */}
      <NewFooterComponent/>
    </div>
  );
}

export default Homepage;
